import { SportFilter } from '@on3/api';

export const filterRankingSports = (sports: SportFilter[] | undefined) => {
  return sports?.filter((sport) => sport.isRankable);
};
